import { render, staticRenderFns } from "./PcEmployerIdentificationNumberTextField.vue?vue&type=template&id=494473d8"
import script from "./PcEmployerIdentificationNumberTextField.vue?vue&type=script&lang=js"
export * from "./PcEmployerIdentificationNumberTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
